export const environment = {
  production: true,

  authRedirectURI: 'https://portfoliodemo.reconcept.nl/login/success/',
  canChangeBE: true,
};
